// Redux
import { combineReducers } from "redux";
// React Router Redux
import { routerReducer } from "react-router-redux";
// Form
import { reducer as formReducer } from "redux-form";
// Reducers
import Auth from "../services/auth.ducks";
import Bookings from "../scenes/Dashboard/Bookings/Bookings.ducks";
import ExamDetails from "../scenes/Dashboard/ExamDetails/ExamDetails.ducks";
import Exams from "../scenes/Dashboard/Exams/Exams.ducks";
import Localization from "../services/localization.ducks";
import Internationalization from "../services/internationalization.ducks";
import SmartNotification from "../components/SmartNotification/SmartNotification.ducks";
import Spinner from "../services/spinner.ducks";
import Users from "../scenes/Dashboard/UsersList/UsersList.ducks";
import Vouchers from "../scenes/Dashboard/Vouchers/Vouchers.ducks";

const combinedReducers = combineReducers({
  auth: Auth,
  bookings: Bookings,
  examDetails: ExamDetails,
  exams: Exams,
  form: formReducer,
  localization: Localization,
  internationalization: Internationalization,
  router: routerReducer,
  smartNotification: SmartNotification,
  spinner: Spinner,
  users: Users,
  vouchers: Vouchers
});

const RESET_STATE = `RESET_STATE`;

export default (state, action) => {
  if (action.type === RESET_STATE) {
    state = {
      localization: state.localization,
      internationalization: state.internationalization
    };
  }
  return combinedReducers(state, action);
};

export const resetState = () => ({
  type: RESET_STATE
});
